const AUTHENTICATION = 'authentication';
export const AUTHENTICATION_URL = `${AUTHENTICATION}/authenticate`;
export const REFRESH_TOKEN_URL = `${AUTHENTICATION}/refreshtoken`;
